import { createContext, useContext } from 'react';

export const BannerContext = createContext();

function useBannerContext() {
  return useContext(BannerContext);
}

export default useBannerContext;
